import { blockNodesVerticalMargin } from '@atlaskit/editor-shared-styles';
export var SmartCardSharedCssClassName = {
  INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
  BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
  EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
  DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
  LOADER_WRAPPER: 'loader-wrapper'
};
export var smartCardSharedStyles = "\n  .".concat(SmartCardSharedCssClassName.BLOCK_CARD_CONTAINER, " {\n    display: block;\n    margin: ").concat(blockNodesVerticalMargin, " 0 0;\n    max-width: ").concat(8 * 95, "px;\n  }\n");